import { useEffect, useState, FC } from 'react';
import { Skeleton, Typography } from '@mui/material';
import { Promo } from '@libs/models';
import { AutocompleteInput } from '@carcareers/components';
import { promoApi } from '@carcareers/store';

interface PromoSelectProps {
  name: string;
}

export const PromoSelect: FC<PromoSelectProps> = ({ name }) => {
  const [promos, setPromos] = useState<Promo[]>([]);

  const { data, isLoading } = promoApi.usePromoActiveQuery({ page: 1, limit: 10 });
  
  useEffect(() => {
    if (data) {
      setPromos(data.items || []);
    }
  }, [data]);

  if (!promos?.length) {
    return <Typography variant="subtitle2">No active promos available</Typography>;
  }

  return isLoading ? (
    <Skeleton variant="rounded" height={56} />
  ) : (
    <AutocompleteInput
      name={name}
      label="Promo Code"
      options={promos.map((promo) => ({ 
        label: `${promo.code} (${promo.type === 'percentage' ? `${promo.discount}%` : `$${promo.discount}`})`, 
        value: promo 
      }))}
    />
  );
};

export default PromoSelect;
